import React, { useEffect } from "react";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { inspectionData } from "../inspectionData";

const styles = StyleSheet.create({
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    height: 64,
    backgroundColor: "#001529",
    padding: "0px 20px",
    alignItems: "center",
    color: "#fff",
  },
  subHeader:{
    display: "flex",
    justifyContent: "space-between",
    height: 55,
    backgroundColor: "#fff",
    padding: "0px 20px",
    alignItems: "center",
    marginBottom: "20px",

  },
  parentCard: {
    flex: 1,
    backgroundColor: "#fff",
    borderRadius: 5,
    display: "flex",
    flexDirection: "column",
    marginBottom: "10px",
    padding:'5px'
  },
  childCard: {
    flex: 1,
    padding: 10,
    border: "1pt solid #ccc",
    borderRadius: 5,
    display: "flex",
    justifyContent: "space-between",
    alignItems:'center',
    marginBottom: "5px",
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 5,
  },
  content: {
    fontSize: 12,
  },
  flag: {
    fontSize: 12,
    marginRight: 5,
    border: "2px solid red",
    padding:'5px',
    borderRadius: 5,
    color:'red'
  },
  done: {
    fontSize: 12,
    marginRight: 5,
    border: "2px solid green",
    padding:'5px',
    borderRadius: 5,
    color:'green'
  },
});

const PrintInspections = () => {
    useEffect(() => {

        window.print();
      }, []);
    
  return (
    
    <Document >
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.title}>test</Text>
          <Text style={styles.title}>Inspection Date: 03/02/2023</Text>
        </View>
        <View style={styles.subHeader}>
          <Text style={styles.title}>Property: test</Text>
        </View>
        {inspectionData.map((item, index) => (
        <View style={styles.parentCard} key={item.key}>
          <Text style={styles.title}>{item.itemCardTitle}</Text>
          {item.items.map((child, index) => (
          <View style={styles.childCard} key={child.key}>
            <Text style={styles.content}>{child.itemTitle}</Text>
            <View>
            {child.isDone &&
            <Text style={styles.content}><i style={styles.done} className="fa-sharp fa-solid fa-circle-check"></i></Text>
            }
            {child.isFollowUp &&
            <Text style={styles.content}><i style={styles.flag} className="fa-solid fa-flag"></i></Text>
            }
            </View>
          </View>
          ))}
        </View>
        ))}
      </Page>
    </Document>
  );
};

export default PrintInspections;
